export default {
  ru: {
    flagSrc: require("@/assets/img/svg/russia.svg"),
    name: "Русский",
    abr: "Ру"
  },
  en: {
    flagSrc: require("@/assets/img/svg/united-kingdom.svg"),
    name: "English",
    abr: "En"
  },
  uz: {
    flagSrc: require("@/assets/img/svg/uzbekistan.svg"),
    name: "Uzbek",
    abr: "Uz"
  },
  oz: {
    flagSrc: require("@/assets/img/svg/uzbekistan.svg"),
    name: "Ўзбекча",
    abr: "Ўз"
  },
  kz: {
    flagSrc: require("@/assets/img/svg/kazakstan.svg"),
    name: "Kazakcha",
    abr: "Kz"
  },
  tj: {
    flagSrc: require("@/assets/img/svg/tajikistan.svg"),
    name: "Tadjikcha",
    abr: "Tj"
  }
}
